import { UserRepository } from "../../api/repo/UserRepository";

export class SearchUserPagePresenter {
    userApiRepo = new UserRepository;

    unLockUserAccount(args) {
        this.userApiRepo.unLockUserAccount(args.searchValue).then(response => {
            const {success, data, error} = response;
            if (success) {
                args.onSuccess && args.onSuccess(data)
            } else {
                args.onError && args.onError(error)
            }
        });
    }

}